import React from "react"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { FormTitle, SubmitButton } from "../../components"
import { useNavigationService } from "../../providers/NavigationService"

export const ResetPasswordSubmittedScreenContent = () => {
  const { navigate } = useNavigationService()
  const { i18n } = useTranslations()

  return (<Container>
    <FormTitle>{i18n("Account.ResetPasswordRequested:Title")}</FormTitle>

    <TextContainer dangerouslySetInnerHTML={{ __html: i18n("Account.ResetPasswordRequested:Description") }} />

    <SubmitButton label={i18n("Account.ForgottenPassword:BackToLogin")}
                  onClick={() => navigate("/login")}/>
  </Container>)
}

const Container = styled("div")({
  display: "grid", rowGap: "20px"
})

const TextContainer = styled("div")({
  "& p": {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: 0,
    margin: 0,
    "&:not(:last-child)": { marginBottom: "20px" }
  }
})
